import { SortableContainer } from "react-sortable-hoc";
import { useCurrentSpaceContext } from "@circle-react/contexts";
import { SortableBookmarkItem } from "./SortableBookmarkItem";
import { SortableListView } from "./SortableListView";
import { SortableBookmark } from "./context/SortableBookmark";

export interface SortableListProps {
  bookmarks: any[];
}

export const SortableList = SortableContainer<SortableListProps>(
  ({ bookmarks }: SortableListProps) => {
    const { data: space } = useCurrentSpaceContext();

    if (!space) return null;

    return (
      <SortableListView>
        {bookmarks.map((bookmark, index) => (
          <SortableBookmark bookmark={bookmark} space={space} key={bookmark.id}>
            <SortableBookmarkItem index={index} />
          </SortableBookmark>
        ))}
      </SortableListView>
    );
  },
);
